import React from 'react'
import { useValidarImagen } from '../../../hooks/useValidarImagen'

const Image = (props) => {
    const { widthImg, heightImg, urlImg, shadowsImg, borderRadiusImagen } = props?.styles

    return (
        <a href={props?.styles?.hipervinculo}>
            <div className='boton-imagen-container'>
                <img
                    className={`${shadowsImg && `z-depth-${shadowsImg}`} img-fluid`}
                    src={useValidarImagen(urlImg)}
                    height={heightImg}
                    width={widthImg}
                    style={{ borderRadius: `${borderRadiusImagen}px` }}
                />
            </div>
        </a>
    )
}

export default Image